import { Context, Middleware } from '@nuxt/types'
import { roles } from '~/shared/const'

/**
 * Редирект на дефолтную страницу на основании текущих ролей пользователя
 */
const redirectToDefault: Middleware = ({ $tstore, redirect, route }: Context) => {
  const user = $tstore.auth.authorizedUser
  if (user !== null && user.roles.size > 0) {
    const firstRole = [...user.roles][0]

    const query: Record<string, any> = {}
    if (route.query.auth) {
      query.auth = route.query.auth
    }

    if (route.query.source === 'company-page-creation' && user.roles.has('company')) {
      return redirect({
        path: '/account/employer-page',
        query
      })
    }

    return redirect({
      path: roles[firstRole].defaultRoute,
      query
    })
  }
  return redirect('/')
}

export default redirectToDefault
